<template>
  <div class="home">
    <div class="amber accent-4 d-none d-sm-none d-md-block d-lg-block d-xl-block top-bar">
      <HeaderBar />
    </div>
    <div>
      <Menu />
    </div>
    <v-container>
      <div class="productdiv" ref="productdiv1"></div>
      <v-card class="mt-1 mx-auto" height="150" elevation="0">
        <div class="
            d-flex
            flex-column
            fill-height
            justify-center
            align-center
            text-black
          ">
          <h1 class="primary--text">
            {{ banner.title }}
          </h1>
        </div>
      </v-card>

      <v-card class="mx-auto" elevation="0">
        <v-row class="mt-5">
          <v-col cols="12" lg="4">
            <div v-html="banner.details" class="text-justify pa-5"></div>
          </v-col>
          <v-col cols="12" lg="8">
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d18671.17263243232!2d77.8302137!3d9.5010777!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cf97bed1fd05%3A0xfec130433034508e!2sPTS%20Crackers!5e1!3m2!1sen!2sin!4v1725368382950!5m2!1sen!2sin"
                width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <loading v-if="loading" />
    <!--footer Component-->
    <div>
      <footerCommon />
    </div>
    <!--footer Component-->
  </div>
</template>

<style scoped>
.top-bar {
  position: fixed;
  width: 100%;
  z-index: 111;
}

.v-application p {
  margin-bottom: 0px;
}

.productdiv {
  margin-top: 125px !important;
}

.banner-text {
  line-height: 50px;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Contactus",
  data: () => ({

  }),
  computed: {
    ...mapGetters([
      "getBannerDetails",
    ]),
    banner: function () {
      return this.getBannerDetails;
    },

  },
  created() {
    this.fetchPageDetails("6");
  },
  methods: {
    ...mapActions([
      "fetchPageDetails",
    ]),

  },
};
</script>
